// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Foreign from "../Foreign/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var map = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity));
var $$undefined = $foreign.undefinedImpl;
var readNullOrUndefined = function (v) {
    return function (v1) {
        if (Foreign.isNull(v1) || Foreign.isUndefined(v1)) {
            return pure(Data_Maybe.Nothing.value);
        };
        return map(Data_Maybe.Just.create)(v(v1));
    };
};
var $$null = $foreign.nullImpl;
export {
    readNullOrUndefined,
    $$undefined as undefined,
    $$null as null
};
